module.exports = __webpack_public_path__ + "static/img/kdSimulator_3.6bc7277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/kdSimulator_3.jpg
// module id = byR2
// module chunks = 1